import { render, staticRenderFns } from "./GeneInputs.vue?vue&type=template&id=2445177c&scoped=true"
import script from "./GeneInputs.vue?vue&type=script&lang=ts"
export * from "./GeneInputs.vue?vue&type=script&lang=ts"
import style0 from "./GeneInputs.vue?vue&type=style&index=0&id=2445177c&prod&scoped=true&lang=scss"
import style1 from "./GeneInputs.vue?vue&type=style&index=1&id=2445177c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445177c",
  null
  
)

export default component.exports